import { ChevronDown } from 'lucide-react';
import { forwardRef, type ComponentPropsWithoutRef, type ReactNode } from 'react';

import { Button } from '@shigo-ui/ui';

import { dashboardTableFilterTriggerClassName } from './DashboardDataTable.styles';

export interface DashboardTableFilterTriggerProps extends Omit<
  ComponentPropsWithoutRef<typeof Button>,
  'children'
> {
  label: ReactNode;
}

export const DashboardTableFilterTrigger = forwardRef<
  HTMLButtonElement,
  DashboardTableFilterTriggerProps
>(({ className, label, type = 'button', variant = 'outline', ...props }, ref) => (
  <Button
    ref={ref}
    type={type}
    variant={variant}
    className={dashboardTableFilterTriggerClassName(className)}
    {...props}
  >
    <span className="truncate">{label}</span>
    <ChevronDown className="h-4 w-4 opacity-50" aria-hidden="true" />
  </Button>
));
DashboardTableFilterTrigger.displayName = 'DashboardTableFilterTrigger';
